module.exports = __webpack_public_path__ + "img/PB_Logo_Org.ca65a37.svg";